import React from "react";
import clsx from "clsx";
import {useDashboardContext} from "../context/dashboard-context.js";
import {
    formatCaseCard
} from "../utils/dashboard-formatters.js";
import {getTaskType} from "../utils/dashboard-filters.js";

const TaskCard = ({task, canShowGarrisonPanel}) => {
    const {cardInteractions, cardInformationHandlers} = useDashboardContext();
    const status = getTaskType(task);
    const interactionCard = {
        type: "task",
        id: task.id,
        state: status,
        item: task,
    };

    return (
        <div
            id={`taskPanel_${task.id}`}
            className={clsx(canShowGarrisonPanel ? "" : "w-[24%]", "task-cards-panel", cardInteractions.getDropClassName(interactionCard))}
            data-card-type="task"
            data-card-state={status}
            data-card-id={task.id}
            data-reason-text={task.reasonText ?? ""}
            data-description={task.description ?? ""}
            data-place={task.placeText ?? ""}
            draggable
            onClick={() => cardInteractions.selectCard(interactionCard)}
            onDoubleClick={() => cardInformationHandlers.openTaskInformation(task)}
            onContextMenu={event => cardInteractions.openContextMenu(event, interactionCard)}
            onDragStart={event => cardInteractions.handleDragStart(event, interactionCard)}
            onDragEnd={cardInteractions.handleDragEnd}
            onDragOver={event => cardInteractions.handleDragOver(event, interactionCard)}
            onDragLeave={() => cardInteractions.handleDragLeave(interactionCard)}
            onDrop={event => cardInteractions.handleDrop(event, interactionCard)}
        >
            <div
                id={`taskPanelSelection_${task.id}`}
                className={clsx("task-card", status, cardInteractions.getSelectionClassName(interactionCard))}
                data-task-source={task.source ?? ""}
                data-task-type={status}
                data-task-id={task.id ?? ""}
                data-garrison-id={task.garrisonId ?? ""}
            >
                <div className={`panel-heading-card ${status}`} />
                <div className={`panel-title-card ${status}`}>
                    <div className="flex-card">
                        <div className="card-panel-body title-card-task">
                            <b className={"truncate"}>{task.reasonText}</b>
                        </div>
                    </div>
                </div>
                <div className={`task-cards-body ${status}`}>
                    {task.description ? (
                        <div className="flex-card">
                            <div className="card-panel-body">
                                <span className={"truncate"}>{task.description}</span>
                            </div>
                        </div>
                    ) : null}
                    <div className="flex-card">
                        <div className="card-panel-body">
                            <span className={"truncate"}>{formatCaseCard(task.placeText)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskCard;
